import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

function Add_Routing_Form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();

    const [routeName, setRouteName] = useState('');
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [Grade, setGrade] = useState('');
    const [responseMessage, setResponseMessage] = useState('');

    useAuth(); // Custom hook for auth

    const Loader = () => (
        <div className="loader-container1">
            <div className="spinner1"></div>
            <p>Loading...</p>
        </div>
    );

    const handleBackClick = () => {
        navigate("/manage_fuel_forms");
    };

    // Fetch locations (branches)
    useEffect(() => {
        const fetchLocations = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}locations`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const result = await response.json();
                if (Array.isArray(result)) {
                    setLocations(result);
                } else {
                    throw new Error("Invalid response format");
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to load locations.');
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, [API_BASE_URL, token]);

    // Fetch user profile
    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const result = await response.json();
                if (result.status) {
                    const { profile } = result;
                    setEmpCode(profile.emp_code || '');
                    setGrade(profile.grade || '');
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, [API_BASE_URL, token]);

    const handleLocationCheckboxChange = (locationId) => {
        setSelectedLocations((prev) =>
            prev.includes(locationId)
                ? prev.filter((id) => id !== locationId)
                : [...prev, locationId]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!routeName.trim()) {
            toast.error("Route name is required");
            return;
        }

        if (selectedLocations.length === 0) {
            toast.error("Please select at least one branch");
            return;
        }

        const payload = {
            route_name: routeName,
            branch_ids: selectedLocations
        }; 
 
        try {
            const response = await fetch(`${API_BASE_URL}save_route`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (response.ok) {
                toast.success("Route saved successfully!");
                setRouteName('');
                setSelectedLocations([]);
            } else {
                toast.error(result.message || "Failed to save route");
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error("Something went wrong");
        }
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Add New Store Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Store Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <Loader />
                    ) : (
                        <section className="content">
                            <div className="container-fluid">
                                <form onSubmit={handleSubmit} className="p-3 card">
                                    <div className="form-group">
                                        <label htmlFor="routeName"><strong>Route Name</strong></label>
                                        <input
                                            type="text"
                                            className="form-control input-font"
                                            id="routeName"
                                            value={routeName}
                                            onChange={(e) => setRouteName(e.target.value)}
                                            placeholder="Enter route name"
                                            required
                                        />
                                    </div>

                                    <div className="form-group mt-3">
                                        <label><strong>Select Branches</strong></label>
                                        <div className="row">
                                            {locations.map((location) => {
                                                const locationName = location.location_name; // use name as ID
                                                return (
                                                    <div className="col-md-4" key={locationName}>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`loc-${locationName}`}
                                                                checked={selectedLocations.includes(locationName)}
                                                                onChange={() => handleLocationCheckboxChange(locationName)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`loc-${locationName}`}>
                                                                {locationName}
                                                            </label>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-success">Submit</button>
                                        <button type="button" onClick={handleBackClick} className="btn btn-secondary ml-2">Back</button>
                                    </div>
                                </form>
                            </div>
                        </section>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    );
}

export default Add_Routing_Form;
